import React, { useState } from "react";
import "./../styles/Navbar.css";
import {Link} from "react-router-dom";

function Navbar() {
    const [menuActive, setMenuActive] = useState(false);
    const toggleMenu = () => {
        setMenuActive(!menuActive);
    };


    return (
        <nav className="navbar">
            <div className="logo"><Link to="/">Curve Intel</Link></div>

            <ul className={`nav-links ${menuActive ? "show" : ""}`}>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
            </ul>

            <div className="navbar-right">
                <div
                    className={`hamburger-menu ${menuActive ? "active" : ""}`}
                    onClick={toggleMenu}
                >
                    &#9776;
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
